// extracted by mini-css-extract-plugin
export default {"pulse":"SplashScreen_pulse__B3phq"};